import { createContext } from 'react';

const ThemeContext = createContext({
    theme: 'dark',
    textColor: 'light',
    backgroundColor: '#343a40',

    /**
     * Although it is possible to remove the following I like to keep them here
     * because they help anyone importing LoadingThemeContext to understand what API (methods)
     * this particular context has available
     * @param {object} theme the theme to update
     */
    setTheme: theme => { }
});

export default ThemeContext;


// WEBPACK FOOTER //
// ./src/context/theme.Context.js